__turbopack_context__.v({
  "body": "_4aVCNq_body",
  "close": "_4aVCNq_close",
  "content": "_4aVCNq_content",
  "cta": "_4aVCNq_cta",
  "description": "_4aVCNq_description",
  "dismiss": "_4aVCNq_dismiss",
  "kortextLogo": "_4aVCNq_kortextLogo",
  "partners": "_4aVCNq_partners",
  "photo": "_4aVCNq_photo",
  "studyStashLogo": "_4aVCNq_studyStashLogo",
  "title": "_4aVCNq_title",
});
